// extracted by mini-css-extract-plugin
export default {"form":"ContactsForm_form__1Y65-","label":"ContactsForm_label__Z7jht","input":"ContactsForm_input__UjXFK","btn":"ContactsForm_btn__qImoL"};